module.exports = __webpack_public_path__ + "img/car_txt.4979ae29.png";